/* Quiz Engine v2.2 — Laqqua
 * Novità v2.1 → v2.2:
 *  - transition screen (no input, solo bottone "Avanti") tra sezioni
 *  - profile card al risultato (sostituisce lede paragrafo)
 *  - question number chip "01" / "02" sopra la domanda
 *  - keyboard support (Enter, Arrow up/down, Esc)
 *  - localStorage save/restore 7 giorni con popup ripresa
 *  - ARIA polish: role="radiogroup"/"group", aria-checked, focus management
 *  - reasons raggruppate in chip "primary" + "contextual" (max 2 chip per card)
 *  - result intro con spiegazione passi routine
 *  - lead form layout rifatto (primary full-width, skip+back inline below)
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-quiz-engine]');
  if (!root) return;

  var treeNode = root.querySelector('script[data-quiz-tree]');
  if (!treeNode) return;
  var DATA;
  try { DATA = JSON.parse(treeNode.textContent); } catch (e) { return; }

  var AVAILABLE = new Set((root.dataset.availableHandles || '').split(',').filter(Boolean));
  DATA.catalog = (DATA.catalog || []).filter(function (p) { return AVAILABLE.has(p.handle); });

  var stage     = root.querySelector('[data-quiz-stage]');
  var resultEl  = root.querySelector('[data-quiz-result]');
  var progress  = root.querySelector('[data-quiz-progress-bar]');
  var stepMarker= root.querySelector('[data-quiz-step-marker]');
  var restartBtn= root.querySelector('[data-quiz-restart]');

  var isInitialLoad = true;
  var keyHandler = null;
  var STORAGE_KEY = 'laqqua_quiz_state_v2_8';
  var STORAGE_TTL_MS = 7 * 24 * 60 * 60 * 1000;

  // Touch detection — gate auto-focus per evitare lo stato "selezionato in azzurro"
  // sulla prima opzione dopo .focus() programmatico su mobile.
  var isCoarsePointer = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);

  // Scroll della pagina al top quando si cambia step (no su initial load).
  // Target = top assoluto della pagina (header incluso), non solo l'inizio della sezione,
  // così l'utente vede chiaramente la nuova domanda dall'inizio.
  function scrollToQuestion() {
    if (isInitialLoad) return;
    if (window.pageYOffset < 8) return; // già in cima
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  /* ---------- State ---------- */
  function freshState() {
    return {
      nodeKey: DATA.start,
      answers: {
        gender: null,
        area: null, age: null, concerns: [], skin_behavior: [], derived_skin_types: [],
        lifestyle: [], life_stage: null, profumo: null, format: null, baby_age: null,
        email: null, consent_marketing: false
      },
      path: []
    };
  }
  var state = freshState();

  /* ---------- Tracking ---------- */
  var KLAVIYO_EVENT_MAP = {
    'quiz_start':         'Quiz Started',
    'quiz_step':          'Quiz Step Completed',
    'quiz_complete':      'Quiz Completed',
    'quiz_lead_capture':  'Quiz Lead Captured',
    'quiz_product_click': 'Quiz Product Clicked',
    'quiz_add_all':       'Quiz Add All To Cart',
    'quiz_resume':        'Quiz Resumed'
  };

  function klaviyoTrack(eventName, payload) {
    // Nuova API SDK (window.klaviyo.track). La vecchia `_learnq.push` non è più
    // processata anche se l'array esiste — si comporta come shim no-op.
    try {
      if (window.klaviyo && typeof window.klaviyo.track === 'function') {
        window.klaviyo.track(eventName, payload);
        return;
      }
    } catch (e) {}
    try {
      if (window._learnq && typeof window._learnq.push === 'function') {
        window._learnq.push(['track', eventName, payload]);
      }
    } catch (e) {}
  }

  function klaviyoIdentify(props) {
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify(props);
        return;
      }
    } catch (e) {}
    try {
      if (window._learnq && typeof window._learnq.push === 'function') {
        window._learnq.push(['identify', props]);
      }
    } catch (e) {}
  }

  function track(event, payload) {
    payload = Object.assign({ quiz_version: DATA.version || 'v2.2' }, payload || {});
    try { if (window.umami && typeof window.umami.track === 'function') window.umami.track(event, payload); } catch (e) {}
    var klEvent = KLAVIYO_EVENT_MAP[event];
    if (klEvent) klaviyoTrack(klEvent, payload);
    try { if (window.dataLayer && typeof window.dataLayer.push === 'function') window.dataLayer.push(Object.assign({ event: event }, payload)); } catch (e) {}
  }

  /* ---------- Persistence (localStorage + URL) ---------- */
  function saveToStorage() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        savedAt: Date.now(),
        state: { nodeKey: state.nodeKey, answers: state.answers, path: state.path }
      }));
    } catch (e) {}
  }
  function loadFromStorage() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.savedAt) return null;
      if (Date.now() - parsed.savedAt > STORAGE_TTL_MS) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return parsed.state;
    } catch (e) { return null; }
  }
  function clearStorage() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  function writeUrlState(replace) {
    try {
      var payload = btoa(JSON.stringify({ answers: state.answers, path: state.path }));
      var url = new URL(window.location.href);
      url.searchParams.set('step', state.nodeKey);
      url.searchParams.set('a', payload);
      history[replace ? 'replaceState' : 'pushState']({ quiz: true, nodeKey: state.nodeKey }, '', url.toString());
    } catch (e) {}
  }
  function readUrlState() {
    try {
      var params = new URLSearchParams(window.location.search);
      var step = params.get('step');
      var payload = params.get('a');
      if (payload) {
        var decoded = JSON.parse(atob(payload));
        if (decoded.answers) state.answers = Object.assign(freshState().answers, decoded.answers);
        if (decoded.path) state.path = decoded.path;
      }
      if (step && (DATA.nodes[step] || step === 'result')) state.nodeKey = step;
    } catch (e) {}
  }

  /* ---------- Progress ---------- */
  // +1 step rispetto a v2.6 perché abbiamo aggiunto la domanda gender all'inizio.
  // Per uomo, -2 step (skip transition_life + life_stage: niente menopausa/gravidanza).
  function estimateTotalSteps() {
    var a = state.answers;
    var maleSkip = (a.gender === 'uomo') ? 2 : 0;
    if (a.area === 'baby')      return 5;
    if (a.area === 'barba')     return 5;
    if (a.area === 'corpo')     return 8 - maleSkip;
    if (a.area === 'capelli')   return 8 - maleSkip;
    if (a.area === 'viso_corpo')return 10 - maleSkip;
    return 9 - maleSkip; // viso default
  }

  // Reorder options per genere. Per uomo, alcuni step hanno options_order_uomo
  // che ridefinisce l'ordine di rilevanza percepita (es. contorno occhi in alto).
  function effectiveOptions(node) {
    if (!node || !node.options) return [];
    var g = state.answers.gender;
    var orderKey = g === 'uomo' ? 'options_order_uomo' : null;
    if (orderKey && node[orderKey] && Array.isArray(node[orderKey])) {
      var lookup = {};
      node.options.forEach(function (opt) { lookup[opt.value] = opt; });
      var reordered = node[orderKey].map(function (v) { return lookup[v]; }).filter(Boolean);
      // Append qualsiasi opzione non listata nell'order array (safety net).
      node.options.forEach(function (opt) {
        if (reordered.indexOf(opt) === -1) reordered.push(opt);
      });
      return reordered;
    }
    return node.options;
  }
  function currentStepNumber() {
    return Math.min(estimateTotalSteps(), state.path.length + 1);
  }
  function updateProgress() {
    var done = state.path.length;
    var total = estimateTotalSteps();
    var pct = state.nodeKey === 'result' ? 100 : Math.max(8, Math.min(95, Math.round((done / total) * 100)));
    if (progress) progress.style.width = pct + '%';
    if (stepMarker) {
      if (state.nodeKey === 'result') {
        stepMarker.style.display = 'none';
      } else {
        stepMarker.style.display = '';
        stepMarker.textContent = currentStepNumber() + ' / ' + total;
        stepMarker.style.left = Math.max(6, Math.min(94, pct)) + '%';
      }
    }
  }

  function stepChip() { return ''; /* unified into progress bar marker */ }

  function capFirst(s) {
    return (s && s.length) ? (s.charAt(0).toUpperCase() + s.slice(1)) : s;
  }

  function parseLabel(label) {
    var m = String(label).match(/^(.+?)\s*\(([^)]+)\)\s*$/);
    if (m) return { main: m[1].trim(), hint: capFirst(m[2].trim()) };
    return { main: label, hint: null };
  }

  function nameFromEmail(email) {
    if (!email) return null;
    var local = String(email).split('@')[0].split('+')[0];
    // Estrai solo se c'è un separatore chiaro (evita "pierluigivagliante" come unico token)
    if (!/[._\-]/.test(local)) return null;
    var first = local.split(/[._\-]/)[0];
    if (!first || first.length < 2 || first.length > 12 || /^\d+$/.test(first)) return null;
    return capFirst(first.toLowerCase());
  }

  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return '';
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  /* Cleanup quando si esce dalla pagina risultato (back, restart, ecc.) */
  function exitResultMode() {
    document.body.classList.remove('quiz-result-active');
    var s = document.querySelector('[data-quiz-sticky]');
    if (s) s.remove();
  }

  /* Offset Gorgias gestito interamente via CSS in theme.css
     ("Gorgias chat — single source of truth"). La body class
     `quiz-result-active` aggiorna --chat-offset-bottom: niente JS qui. */

  /* ---------- Result items (with prices + included flag) ---------- */
  var resultItems = [];

  function fetchProductData(handle) {
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j) return null;
        var v = (j.variants || []).find(function (x) { return x.available; }) || (j.variants || [])[0];
        var img = j.featured_image || (j.images && j.images[0]) || '';
        if (img && img.indexOf('http') !== 0 && img.indexOf('//') === 0) img = 'https:' + img;
        else if (img && img.indexOf('http') !== 0 && img.indexOf('/') === 0) img = 'https://www.laqqua.com' + img;
        return {
          price: j.price,
          variantId: v ? v.id : null,
          title: j.title,
          image: img,
          description: j.description || ''
        };
      })
      .catch(function () { return null; });
  }

  /* ---------- Label getters (per arricchire eventi Klaviyo) ---------- */
  function getAreaLabel(area) {
    return ({
      'viso': 'Viso',
      'corpo': 'Corpo',
      'capelli': 'Capelli',
      'viso_corpo': 'Viso e corpo',
      'baby': 'Per il bimbo',
      'barba': 'Barba'
    })[area] || (area ? capFirst(String(area).replace(/_/g, ' ')) : '');
  }
  function getGenderLabel(g) {
    if (!g || g === 'altro') return '';
    return (DATA.gender_labels && DATA.gender_labels[g]) || g;
  }
  function getProfumoLabel(p) {
    return ({ 'si': 'I profumi mi piacciono', 'leggero': 'Profumi naturali e leggeri', 'no': 'Senza profumo' })[p] || '';
  }
  function getFormatLabel(f) {
    return ({ 'completa': 'Routine completa', 'mini': 'Mini routine', 'essenziale': 'Solo un prodotto' })[f] || '';
  }
  function getLifeStageLabel(ls) {
    if (!ls || ls === 'nessuna' || ls === 'skip') return '';
    return (DATA.life_stage_labels && DATA.life_stage_labels[ls]) || capFirst(String(ls).replace(/-/g, ' '));
  }
  function getAgeLabel(age) {
    if (!age || age === 'skip') return '';
    return (DATA.age_labels && DATA.age_labels[age]) || age;
  }
  function getLifestyleLabels(arr) {
    return (arr || []).filter(function (lf) { return lf !== 'nessuna'; }).map(function (lf) {
      return (DATA.lifestyle_labels && DATA.lifestyle_labels[lf]) || lf;
    });
  }
  function getConcernLabels(arr) {
    return (arr || []).map(function (c) {
      return capFirst((DATA.concern_labels && DATA.concern_labels[c]) || String(c).replace(/_/g, ' '));
    });
  }
  function getStepInfo(step) {
    return (DATA.step_labels && DATA.step_labels[step]) || { name: step, usage: '' };
  }

  function updateBundleSummary() {
    var included = resultItems.filter(function (x) { return x.included && x.price != null; });
    var count = included.length;
    var totalCents = included.reduce(function (s, x) { return s + (x.price || 0); }, 0);
    var priceText = formatMoney(totalCents);
    var countText = count === 1 ? '1 prodotto' : count + ' prodotti';
    var valueText = count === 0 ? '...' : (countText + ' · ' + priceText);

    // Testo bottone in base al count
    var btnText;
    if (count === 0)      btnText = 'Seleziona almeno un prodotto';
    else if (count === 1) btnText = 'Aggiungi al carrello';
    else                  btnText = 'Aggiungi tutto al carrello';

    var stickyBtnText;
    if (count === 0)      stickyBtnText = 'Aggiungi';
    else if (count === 1) stickyBtnText = 'Aggiungi al carrello';
    else                  stickyBtnText = 'Aggiungi tutto';

    // Sticky (l'intero <button> è cliccabile, visibile su tutte le viewport)
    var sticky = document.querySelector('[data-quiz-sticky]');
    if (sticky) {
      sticky.querySelector('[data-sticky-count]').textContent = countText;
      sticky.querySelector('[data-sticky-price]').textContent = priceText;
      sticky.disabled = (count === 0);
      var slabel = sticky.querySelector('[data-sticky-label]');
      if (slabel) slabel.textContent = stickyBtnText;
    }
  }

  /* ---------- Skin type derivation ---------- */
  // 'lucida' è ora un unico segnale (era split in lucida_t/lucida_tutto).
  // 'pori' è nuovo: pori dilatati → grassa/mista (segnale forte di sebo).
  function deriveSkinTypes(behaviors) {
    var derived = new Set();
    var has = function (v) { return behaviors.indexOf(v) !== -1; };
    // Lucida o pori → segnale sebo: tratta come mista E grassa (inclusivo).
    if (has('lucida') || has('pori')) { derived.add('mista'); derived.add('grassa'); }
    // Tira: secca, salvo concomitanze con segnali sebo (allora mista + disidratata).
    if (has('tira') && !has('lucida') && !has('pori')) derived.add('secca');
    if (has('tira') && (has('lucida') || has('pori'))) { derived.add('mista'); derived.add('disidratata'); }
    if (has('reattiva')) derived.add('sensibile');
    if (has('disidratata')) derived.add('disidratata');
    if (has('nessuna') && derived.size === 0) derived.add('normale');
    if (derived.size === 0) derived.add('normale');
    return Array.from(derived);
  }

  /* ---------- Flow control ---------- */
  function nextNodeFor(currentKey, opt) {
    var n = DATA.nodes[currentKey];
    if (!n) return 'result';
    if (opt && opt.next) return opt.next;
    // viso_corpo: dopo skin_behavior va su concern_corpo, e da concern_corpo va su lifestyle
    if (currentKey === 'concern_corpo' && state.answers.area === 'viso_corpo') return 'lifestyle';
    if (currentKey === 'skin_behavior' && state.answers.area === 'viso_corpo') return 'concern_corpo';
    // Per uomo: skip transition_life + life_stage (gravidanza/menopausa non applicabili).
    // Da lifestyle si va direttamente a profumo. Safety net: anche se per qualche
    // motivo l'utente uomo finisce su transition_life o life_stage, salta a profumo.
    if (currentKey === 'lifestyle' && state.answers.gender === 'uomo') return 'profumo';
    if (currentKey === 'transition_life' && state.answers.gender === 'uomo') return 'profumo';
    if (currentKey === 'life_stage') return 'profumo';
    if (currentKey === 'concern_barba') return 'lead_capture';
    return n.next || 'result';
  }

  /* ---------- Resume prompt ---------- */
  function maybePromptResume() {
    var saved = loadFromStorage();
    if (!saved || !saved.nodeKey || saved.nodeKey === DATA.start || saved.nodeKey === 'result') {
      return false;
    }
    var hasUrlState = new URLSearchParams(window.location.search).get('a');
    if (hasUrlState) return false; // user arrived with URL state, don't override

    var html = '<div class="quiz-step quiz-resume" data-step="_resume">';
    html += '<h2 class="quiz-step__question">Riprendiamo da dove eri rimasta?</h2>';
    html += '<p class="quiz-step__subtitle">Hai iniziato il quiz di recente. Vuoi continuare con le risposte già date?</p>';
    html += '<div class="quiz-step__nav quiz-step__nav--center">';
    html += '<button type="button" class="quiz-btn quiz-btn--ghost" data-quiz-fresh>Ricomincio da capo</button>';
    html += '<button type="button" class="quiz-btn" data-quiz-resume>Riprendi</button>';
    html += '</div></div>';
    stage.innerHTML = html;

    stage.querySelector('[data-quiz-resume]').addEventListener('click', function () {
      state.nodeKey = saved.nodeKey;
      state.answers = Object.assign(freshState().answers, saved.answers || {});
      state.path = saved.path || [];
      track('quiz_resume', { node: state.nodeKey, step: state.path.length + 1 });
      if (state.nodeKey === 'result') renderResult();
      else {
        var n = DATA.nodes[state.nodeKey];
        if (n && n.type === 'lead_form') renderLeadForm(n);
        else if (n && n.type === 'transition') renderTransition(n);
        else renderNode();
      }
    });
    stage.querySelector('[data-quiz-fresh]').addEventListener('click', function () {
      clearStorage();
      state = freshState();
      renderNode();
    });
    // Resume prompt = stato di pausa, non un vero step del quiz.
    // Nascondo lo step marker (era hardcoded "1 / 1" nel DOM) e azzero la barra.
    if (progress) progress.style.width = '0%';
    if (stepMarker) stepMarker.style.display = 'none';
    return true;
  }

  /* ---------- Render question ---------- */
  function renderNode(skipUrl) {
    exitResultMode();
    var node = DATA.nodes[state.nodeKey];
    if (!node) { state.nodeKey = DATA.start; node = DATA.nodes[state.nodeKey]; }
    if (node.type === 'lead_form') return renderLeadForm(node, skipUrl);
    if (node.type === 'transition') return renderTransition(node, skipUrl);

    var isMulti  = node.type === 'multi';
    var max      = node.max || Infinity;
    var selected = new Set();
    var renderOpts = effectiveOptions(node);
    // Sostituisci temporaneamente node.options con l'ordine effettivo per assicurare
    // che commitAnswer e altri consumer leggano lo stesso ordine renderizzato.
    var origOptions = node.options;
    node.options = renderOpts;
    var manyCols = (renderOpts || []).length > 3;

    var html = '<div class="quiz-step" data-step="' + state.nodeKey + '">';
    html += stepChip();
    html += '<h2 class="quiz-step__question" id="quizQ-' + state.nodeKey + '">' + esc(node.question) + '</h2>';
    if (node.subtitle) html += '<p class="quiz-step__subtitle">' + esc(node.subtitle) + '</p>';

    html += '<div class="quiz-step__options ' + (manyCols ? '' : 'quiz-step__options--single-col') + '"';
    html += ' data-multi="' + (isMulti ? 'true' : 'false') + '"';
    html += ' role="' + (isMulti ? 'group' : 'radiogroup') + '"';
    html += ' aria-labelledby="quizQ-' + state.nodeKey + '"';
    html += '>';
    (renderOpts || []).forEach(function (opt, i) {
      var parsed = parseLabel(opt.label);
      html += '<button type="button" class="quiz-option" data-i="' + i + '"';
      html += ' role="' + (isMulti ? 'checkbox' : 'radio') + '"';
      html += ' aria-checked="false" tabindex="' + (i === 0 ? '0' : '-1') + '">';
      html += '<span class="quiz-option__label">';
      html += '<span class="quiz-option__label-main">' + esc(parsed.main) + '</span>';
      if (parsed.hint) html += '<span class="quiz-option__label-hint">' + esc(parsed.hint) + '</span>';
      html += '</span>';
      html += '<span class="quiz-option__check" aria-hidden="true"></span>';
      html += '</button>';
    });
    html += '</div>';

    var hasBack = state.path.length > 0;
    var hasNext = isMulti;
    if (hasBack || hasNext) {
      html += '<div class="quiz-step__nav' + (hasBack && hasNext ? '' : ' quiz-step__nav--single') + '">';
      if (hasBack) html += '<button type="button" class="quiz-btn quiz-btn--ghost" data-quiz-back>Indietro</button>';
      if (hasNext) html += '<button type="button" class="quiz-btn" data-quiz-next disabled>Continua</button>';
      html += '</div>';
    }
    html += '</div>';

    stage.innerHTML = html;
    resultEl.hidden = true;
    if (restartBtn) restartBtn.hidden = true;

    var nextBtn = stage.querySelector('[data-quiz-next]');
    var optionEls = Array.from(stage.querySelectorAll('.quiz-option'));

    var advancing = false;
    optionEls.forEach(function (btn, idx) {
      btn.addEventListener('click', function () {
        if (isMulti) {
          if (selected.has(idx)) { selected.delete(idx); btn.setAttribute('aria-checked', 'false'); }
          else {
            if (selected.size >= max) return;
            selected.add(idx); btn.setAttribute('aria-checked', 'true');
          }
          if (nextBtn) {
            nextBtn.disabled = selected.size === 0;
            var counter = (max < Infinity) ? (' (' + selected.size + '/' + max + ')') : (selected.size > 0 ? (' (' + selected.size + ')') : '');
            nextBtn.textContent = 'Continua' + counter;
          }
        } else {
          if (advancing) return;
          advancing = true;
          // Visual feedback: marca selezionato + disabilita gli altri, poi avanza
          optionEls.forEach(function (el) { el.setAttribute('aria-checked', el === btn ? 'true' : 'false'); });
          setTimeout(function () { commitAnswer(node, [idx]); }, 320);
        }
      });
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      if (selected.size === 0) return;
      commitAnswer(node, Array.from(selected));
    });
    var backBtn = stage.querySelector('[data-quiz-back]');
    if (backBtn) backBtn.addEventListener('click', goBack);

    bindKeyboard({
      type: 'options',
      isMulti: isMulti,
      optionEls: optionEls,
      onConfirm: function () {
        if (isMulti && nextBtn && !nextBtn.disabled) nextBtn.click();
      },
      onBack: function () { if (backBtn) backBtn.click(); }
    });

    // Nessun auto-focus sulla prima opzione: evita l'effetto priming/pre-selezione.
    // Gli utenti tastiera possono comunque entrare nelle opzioni con Tab.

    scrollToQuestion();
    updateProgress();
    if (!skipUrl) writeUrlState(isInitialLoad);
    isInitialLoad = false;
  }

  /* ---------- Transition screen ---------- */
  function renderTransition(node, skipUrl) {
    exitResultMode();
    var html = '<div class="quiz-step quiz-step--transition" data-step="' + state.nodeKey + '">';
    html += stepChip();
    html += '<h2 class="quiz-step__question">' + esc(node.question) + '</h2>';
    if (node.subtitle) html += '<p class="quiz-step__subtitle">' + esc(node.subtitle) + '</p>';
    html += '<div class="quiz-step__nav quiz-step__nav--center">';
    if (state.path.length > 0) html += '<button type="button" class="quiz-btn quiz-btn--ghost" data-quiz-back>Indietro</button>';
    html += '<button type="button" class="quiz-btn" data-quiz-go autofocus>' + esc(node.submit_label || 'Avanti') + '</button>';
    html += '</div></div>';

    stage.innerHTML = html;
    resultEl.hidden = true;
    if (restartBtn) restartBtn.hidden = true;

    var goBtn = stage.querySelector('[data-quiz-go]');
    var backBtn = stage.querySelector('[data-quiz-back]');
    goBtn.addEventListener('click', function () {
      state.path.push({ node: state.nodeKey, key: node.key || '_transition', value: 'next' });
      track('quiz_step', { step: state.path.length, node: state.nodeKey, key: '_transition' });
      state.nodeKey = node.next || 'result';
      writeUrlState(false);
      saveToStorage();
      if (state.nodeKey === 'result') renderResult();
      else renderNode(true);
    });
    if (backBtn) backBtn.addEventListener('click', goBack);

    bindKeyboard({
      type: 'transition',
      onConfirm: function () { goBtn.click(); },
      onBack: function () { if (backBtn) backBtn.click(); }
    });

    // Nessun auto-focus sul bottone Continua della transition step.
    scrollToQuestion();

    updateProgress();
    if (!skipUrl) writeUrlState(isInitialLoad);
    isInitialLoad = false;
  }

  /* ---------- Lead form ---------- */
  function renderLeadForm(node, skipUrl) {
    exitResultMode();
    var html = '<div class="quiz-step quiz-step--lead" data-step="lead_capture">';
    html += stepChip();
    html += '<h2 class="quiz-step__question">' + esc(node.question) + '</h2>';
    if (node.subtitle) html += '<p class="quiz-step__subtitle">' + esc(node.subtitle) + '</p>';
    html += '<form class="quiz-lead" data-quiz-lead-form novalidate>';
    html +=   '<label class="quiz-lead__field">';
    html +=     '<span class="quiz-lead__label">Email</span>';
    html +=     '<input type="email" name="email" required autocomplete="email" placeholder="nome.cognome@email.com" class="quiz-lead__input">';
    html +=   '</label>';
    html +=   '<label class="quiz-lead__consent">';
    html +=     '<input type="checkbox" name="consent">';
    html +=     '<span>Se non sei già iscritta, iscrivimi alle novità Laqqua per offerte e consigli skincare.</span>';
    html +=   '</label>';
    html +=   '<button type="submit" class="quiz-btn quiz-btn--full">' + esc(node.submit_label || 'Mostrami i risultati') + '</button>';
    html +=   '<div class="quiz-lead__secondary">';
    html +=     '<button type="button" class="quiz-btn quiz-btn--ghost quiz-lead__back-btn" data-quiz-back>Indietro</button>';
    html +=     '<button type="button" class="quiz-btn quiz-btn--ghost quiz-lead__skip" data-quiz-skip>' + esc(node.skip_label || 'Continua senza email') + '</button>';
    html +=   '</div>';
    html +=   '<p class="quiz-lead__optional">L\'email è opzionale: puoi vedere i risultati anche senza lasciarla.</p>';
    html += '</form>';
    html += '</div>';

    stage.innerHTML = html;
    resultEl.hidden = true;

    var form = stage.querySelector('[data-quiz-lead-form]');
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var email = (form.email.value || '').trim();
      var consent = !!form.consent.checked;
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        form.email.focus();
        form.email.setAttribute('aria-invalid', 'true');
        return;
      }
      state.answers.email = email;
      state.answers.consent_marketing = consent;
      submitLead(email, consent);
      state.path.push({ node: 'lead_capture', key: 'email', value: 'provided' });
      state.nodeKey = 'result';
      writeUrlState(false);
      saveToStorage();
      renderResult();
    });

    stage.querySelector('[data-quiz-skip]').addEventListener('click', function () {
      state.path.push({ node: 'lead_capture', key: 'email', value: 'skipped' });
      state.nodeKey = 'result';
      track('quiz_lead_capture', { provided: false });
      writeUrlState(false);
      saveToStorage();
      renderResult();
    });

    stage.querySelector('[data-quiz-back]').addEventListener('click', goBack);

    bindKeyboard({ type: 'lead' });

    // Niente auto-focus: su iOS causa zoom indesiderato sul campo email
    scrollToQuestion();
    updateProgress();
    if (!skipUrl) writeUrlState(isInitialLoad);
    isInitialLoad = false;
  }

  function submitLead(email, consent) {
    var a = state.answers;
    var props = {
      '$email': email,
      'QuizGender': a.gender,
      'QuizArea': a.area, 'QuizAge': a.age, 'QuizConcerns': a.concerns,
      'QuizSkinTypes': a.derived_skin_types, 'QuizLifestyle': a.lifestyle,
      'QuizLifeStage': a.life_stage,
      'QuizFormat': a.format, 'QuizProfumo': a.profumo,
      'QuizConsent': consent
    };
    klaviyoIdentify(props);
    if (consent) {
      klaviyoTrack('Quiz Marketing Opt-In', { source: 'quiz' });
    }
    track('quiz_lead_capture', { provided: true, consent: consent });
  }

  /* ---------- Keyboard ---------- */
  function bindKeyboard(cfg) {
    if (keyHandler) document.removeEventListener('keydown', keyHandler);
    keyHandler = function (ev) {
      // Don't hijack typing in inputs
      var tag = (ev.target && ev.target.tagName) || '';
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;

      if (cfg.type === 'options' && cfg.optionEls) {
        var els = cfg.optionEls;
        var idx = els.indexOf(document.activeElement);
        if (ev.key === 'ArrowDown' || ev.key === 'ArrowRight') {
          ev.preventDefault();
          var next = (idx + 1) % els.length;
          els.forEach(function (e, i) { e.setAttribute('tabindex', i === next ? '0' : '-1'); });
          els[next].focus();
        } else if (ev.key === 'ArrowUp' || ev.key === 'ArrowLeft') {
          ev.preventDefault();
          var prev = (idx <= 0 ? els.length - 1 : idx - 1);
          els.forEach(function (e, i) { e.setAttribute('tabindex', i === prev ? '0' : '-1'); });
          els[prev].focus();
        } else if (ev.key === 'Enter' || ev.key === ' ') {
          if (document.activeElement && document.activeElement.classList.contains('quiz-option')) {
            ev.preventDefault();
            document.activeElement.click();
          } else if (cfg.onConfirm) {
            ev.preventDefault();
            cfg.onConfirm();
          }
        } else if (ev.key === 'Escape' || ev.key === 'Backspace') {
          if (cfg.onBack) { ev.preventDefault(); cfg.onBack(); }
        }
      } else if (cfg.type === 'transition') {
        if (ev.key === 'Enter' || ev.key === ' ') {
          ev.preventDefault();
          if (cfg.onConfirm) cfg.onConfirm();
        } else if (ev.key === 'Escape' || ev.key === 'Backspace') {
          if (cfg.onBack) { ev.preventDefault(); cfg.onBack(); }
        }
      }
    };
    document.addEventListener('keydown', keyHandler);
  }

  /* ---------- Commit answer ---------- */
  function commitAnswer(node, indices) {
    var values = indices.map(function (i) { return node.options[i].value; });

    if (node.key) {
      if (node.type === 'multi') {
        if (node.key === 'concerns') {
          var setC = new Set(state.answers.concerns || []);
          values.forEach(function (v) { if (v != null) setC.add(v); });
          state.answers.concerns = Array.from(setC);
        } else if (node.key === 'skin_behavior') {
          state.answers.skin_behavior = values.slice();
          state.answers.derived_skin_types = deriveSkinTypes(values);
        } else {
          state.answers[node.key] = values.slice();
        }
      } else {
        state.answers[node.key] = values[0];
        var opt0 = node.options[indices[0]];
        if (opt0 && opt0.set) {
          Object.keys(opt0.set).forEach(function (k) {
            if (k.endsWith('+')) {
              var realKey = k.slice(0, -1);
              if (!Array.isArray(state.answers[realKey])) state.answers[realKey] = [];
              if (state.answers[realKey].indexOf(opt0.set[k]) === -1) state.answers[realKey].push(opt0.set[k]);
            } else {
              state.answers[k] = opt0.set[k];
            }
          });
        }
      }
    }

    if (node.key === 'skin_behavior') {
      track('quiz_step', { step: state.path.length + 1, node: state.nodeKey, key: 'skin_behavior_raw', value: values, derived_skin_types: state.answers.derived_skin_types });
    } else {
      track('quiz_step', { step: state.path.length + 1, node: state.nodeKey, key: node.key, value: values.length === 1 ? values[0] : values });
    }

    state.path.push({ node: state.nodeKey, key: node.key, value: values });
    state.nodeKey = nextNodeFor(state.nodeKey, node.type === 'single' ? node.options[indices[0]] : null);
    writeUrlState(false);
    saveToStorage();

    if (state.nodeKey === 'result') renderResult();
    else renderNode(true);
  }

  function goBack() {
    if (state.path.length === 0) { history.back(); return; }
    var last = state.path.pop();
    state.nodeKey = last.node;
    if (last.key === 'concerns') {
      var setC = new Set(state.answers.concerns || []);
      (last.value || []).forEach(function (v) { setC.delete(v); });
      state.answers.concerns = Array.from(setC);
    } else if (last.key === 'skin_behavior') {
      state.answers.skin_behavior = [];
      state.answers.derived_skin_types = [];
    } else if (last.key === 'email') {
      state.answers.email = null; state.answers.consent_marketing = false;
    } else if (last.key && last.key !== '_transition') {
      state.answers[last.key] = null;
    }
    history.back();
  }

  window.addEventListener('popstate', function (ev) {
    if (!ev.state || !ev.state.quiz) return;
    readUrlState();
    var node = DATA.nodes[state.nodeKey];
    if (state.nodeKey === 'result') renderResult();
    else if (node && node.type === 'lead_form') renderLeadForm(node, true);
    else if (node && node.type === 'transition') renderTransition(node, true);
    else if (node) renderNode(true);
  });

  /* ---------- Scoring ---------- */
  function isKnockedOut(p, a) {
    if (a.area === 'baby' && p.audience !== 'baby') return true;
    if (a.area === 'barba' && p.audience !== 'barba' && !p.is_set) return true;
    if (a.area !== 'baby' && p.audience === 'baby') return true;
    if (a.area !== 'barba' && p.audience === 'barba') return true;
    if ((a.derived_skin_types || []).indexOf('sensibile') !== -1 && (p.flags || []).indexOf('acidi_attivi') !== -1) return true;
    if (a.concerns && a.concerns.indexOf('sensibile_concern') !== -1 && (p.flags || []).indexOf('acidi_attivi') !== -1) return true;
    // Sicurezza ingredienti: gravidanza + allattamento + post-parto consolidato.
    // Il valore 'post-parto' nel nuovo tree copre anche "allattamento" → blocco retinoidi.
    if (a.life_stage === 'gravidanza' || a.life_stage === 'allattamento' || a.life_stage === 'post-parto') {
      var fl = p.flags || [];
      if (fl.indexOf('retinoidi') !== -1 || fl.indexOf('olio_essenziale') !== -1) return true;
    }
    if (a.profumo === 'no' && p.has_fragrance === true) return true;
    return false;
  }

  function scoreCatalog() {
    var a = state.answers;
    return DATA.catalog.map(function (p) {
      if (isKnockedOut(p, a)) return null;
      var score = 0;
      var matchedConcerns = [];
      var matchedSkin = [];
      var matchedLifeStage = null;
      var fragranceFree = false;

      (a.concerns || []).forEach(function (c) {
        var v = (p.concerns && p.concerns[c]) || 0;
        if (v > 0) {
          score += v * 2;
          if (v >= 2) matchedConcerns.push((DATA.concern_labels && DATA.concern_labels[c]) || c);
        }
      });
      (a.derived_skin_types || []).forEach(function (st) {
        var v = (p.skin_types && p.skin_types[st]) || 0;
        if (v > 0) {
          score += v;
          if (v >= 2) matchedSkin.push(st);
        }
      });

      // Age boost: 6 bucket allineati al sondaggio.
      // 18-24/25-34 → prevenzione; 35-44 → mix; 45+ → rughe + pelle_stanca.
      var pc = p.concerns || {};
      if (a.age === '18_24') {
        score += (pc.prevenzione || 0) * 1.5;
        if ((pc.rughe || 0) >= 3) score -= 1.5; // anti-age intenso non adatto
      } else if (a.age === '25_34') {
        score += (pc.prevenzione || 0) * 1.2;
        score += (pc.rughe || 0) * 0.3;
      } else if (a.age === '35_44') {
        score += (pc.rughe || 0) * 0.7;
        score += (pc.prevenzione || 0) * 0.4;
        score += (pc.idratazione || 0) * 0.3;
      } else if (a.age === '45_54') {
        score += (pc.rughe || 0) * 1.2;
        score += (pc.pelle_stanca || 0) * 0.5;
      } else if (a.age === '55_64') {
        score += (pc.rughe || 0) * 1.5;
        score += (pc.pelle_stanca || 0) * 0.8;
        score += (pc.idratazione || 0) * 0.3;
      } else if (a.age === '65_plus') {
        score += (pc.rughe || 0) * 1.5;
        score += (pc.pelle_stanca || 0) * 1;
        score += (pc.idratazione || 0) * 0.5;
      }

      // Safety net: l'opzione "Misti" capelli è stata rimossa per simmetria 6 opzioni.
      // Se l'utente seleziona sia capelli_grassi che capelli_secchi → tratta come misti
      // e booster i prodotti che scorano sul concern capelli_misti.
      if (a.concerns && a.concerns.indexOf('capelli_grassi') !== -1 && a.concerns.indexOf('capelli_secchi') !== -1) {
        score += (pc.capelli_misti || 0) * 1.5;
      }

      // Lifestyle boost: stress/sole/inquinamento/aria_secca/sonno → concerns correlati
      (a.lifestyle || []).forEach(function (lf) {
        if (!p.concerns) return;
        if (lf === 'sole')         { score += (p.concerns.macchie || 0) * 0.6 + (p.concerns.prevenzione || 0) * 0.4; }
        if (lf === 'stress')       { score += (p.concerns.pelle_stanca || 0) * 0.6 + (p.concerns.idratazione || 0) * 0.2; }
        if (lf === 'inquinamento') { score += (p.concerns.pelle_stanca || 0) * 0.5 + (p.concerns.macchie || 0) * 0.3; }
        if (lf === 'aria_secca')   { score += (p.concerns.idratazione || 0) * 0.7 + (p.concerns.sensibile_concern || 0) * 0.3; }
        if (lf === 'sonno')        { score += (p.concerns.occhiaie || 0) * 0.7 + (p.concerns.pelle_stanca || 0) * 0.3; }
      });

      // Life-stage boost:
      //  - "post-parto" answer copre sia allattamento che post-parto (consolidati).
      //  - "pre-menopausa" è nuovo: boost lieve sui prodotti taggati menopausa.
      var lifeMatch = false;
      var lifeBoost = 3;
      if (a.life_stage && p.life_stage_boost) {
        if (p.life_stage_boost.indexOf(a.life_stage) !== -1) lifeMatch = true;
        else if (a.life_stage === 'post-parto' && p.life_stage_boost.indexOf('allattamento') !== -1) lifeMatch = true;
        else if (a.life_stage === 'pre-menopausa' && p.life_stage_boost.indexOf('menopausa') !== -1) { lifeMatch = true; lifeBoost = 2; }
      }
      if (lifeMatch) {
        score += lifeBoost;
        matchedLifeStage = (DATA.life_stage_labels && DATA.life_stage_labels[a.life_stage]) || a.life_stage;
      }

      var catMatch = matchCategory(p.category, a.area);
      if (catMatch === 'match') score += 2;
      else if (catMatch === 'mismatch') score -= 1;

      // Bundle/set bias RIPRISTINATO (decisione strategica Pierluigi 2026-05-26):
      // anche se le vendite storiche bundle sono basse, vogliamo testare se
      // proporli come hero alza il CVR (assunzione: l'utente preferisce 1 scelta
      // composta a 4 scelte singole, più semplice da approvare).
      if (p.is_set) score += 5;

      // Gender bias: per uomo, i prodotti specifici per barba salgono fortemente.
      // Per donna nessun bias diretto (il catalogo è prevalentemente femminile).
      if (a.gender === 'uomo' && (p.category === 'barba' || p.audience === 'barba')) {
        score += 4;
      }

      if (a.profumo === 'si' && p.has_fragrance === true) score += 1;
      if (a.profumo === 'leggero' && p.has_fragrance === false) score += 1;
      if (a.profumo === 'no' && p.has_fragrance === false) { score += 2; fragranceFree = true; }

      // Sales-weighted boost: log2(1 + units_sold_90d) * 0.8.
      // Tra due prodotti pari-match vince quello con CVR provata.
      // Knockout filter ha già escluso prodotti cross-audience (baby, barba),
      // quindi il boost si applica solo a prodotti rilevanti per l'area.
      var sales = (DATA.sales_90d && DATA.sales_90d[p.handle]) || 0;
      if (sales > 0) score += Math.log2(1 + sales) * 0.8;

      return {
        handle: p.handle, score: score, step: p.step, is_set: !!p.is_set, category: p.category,
        match: { concerns: matchedConcerns, skin: matchedSkin, life_stage: matchedLifeStage, fragranceFree: fragranceFree }
      };
    }).filter(function (x) { return x && x.score > 0; })
      .sort(function (x, y) { return y.score - x.score; });
  }

  function matchCategory(prodCat, area) {
    if (!area) return 'neutral';
    if (area === 'viso')       return prodCat === 'skincare' ? 'match' : 'mismatch';
    if (area === 'corpo')      return prodCat === 'corpo'    ? 'match' : 'mismatch';
    if (area === 'capelli')    return prodCat === 'capelli'  ? 'match' : 'mismatch';
    if (area === 'baby')       return prodCat === 'baby'     ? 'match' : 'mismatch';
    if (area === 'barba')      return prodCat === 'barba'    ? 'match' : 'mismatch';
    if (area === 'viso_corpo') return (prodCat === 'skincare' || prodCat === 'corpo' || prodCat === 'multi') ? 'match' : 'mismatch';
    return 'neutral';
  }

  function pickWithDiversity(ranked) {
    var a = state.answers;
    // Format rimosso dal quiz: default 'completa'.
    var fmt = a.format || 'completa';

    // "Solo un prodotto per provare" (legacy URL) → esattamente 1
    if (fmt === 'essenziale') {
      return ranked.slice(0, 1);
    }

    // Default steps per area — ordinati per priorità nella mini routine
    var hasOcchiaie = a.concerns && a.concerns.indexOf('occhiaie') !== -1;
    var visoSteps = hasOcchiaie
      ? ['detersione', 'contorno_occhi', 'idratazione', 'trattamento', 'olio']
      : ['detersione', 'idratazione', 'trattamento', 'contorno_occhi', 'olio'];
    var stepsForArea = {
      'viso':       visoSteps,
      'corpo':      ['corpo_detergente', 'corpo_idratante', 'olio_corpo', 'corpo_intimo'],
      'capelli':    ['shampoo', 'balsamo', 'capelli_olio'],
      'viso_corpo': hasOcchiaie
        ? ['detersione', 'contorno_occhi', 'idratazione', 'corpo_detergente', 'corpo_idratante', 'olio_corpo', 'trattamento']
        : ['detersione', 'idratazione', 'trattamento', 'corpo_detergente', 'corpo_idratante', 'olio_corpo', 'contorno_occhi'],
      'baby':       ['baby_detergente', 'baby_idratante'],
      'barba':      ['barba_modellante', 'barba_idratante']
    };
    var desiredSteps = stepsForArea[a.area] || [];
    // Aggressively bounded: 1 hero + 3 routine = max 4 prodotti totali.
    // Allineato con AOV €60: anchor iniziale (solo hero selected) ~€25-35.
    // Anche se utente seleziona tutti, totale resta sotto €100.
    var n = 4;

    // Filtro categoria stretto: se l'area è viso, mai mostrare prodotti corpo
    // anche se hanno score positivo per life_stage_boost o concerns generali.
    // Bug riscontrato: olio_corpo appariva su area=viso perché il fallback fill
    // pescava da tutto ranked ignorando matchCategory.
    var stepsAllowed = new Set(desiredSteps);
    var rankedFiltered = ranked.filter(function (r) {
      var cat = (DATA.catalog.find(function (p) { return p.handle === r.handle; }) || {}).category;
      return matchCategory(cat, a.area) !== 'mismatch';
    });

    var picked = [];
    var usedHandles = new Set();
    // Niente bundle-first: il bias era controproducente (0 vendite bundle in 90gg).
    // I bundle restano in rankedFiltered ma competono come singoli prodotti.
    desiredSteps.forEach(function (s) {
      if (picked.length >= n) return;
      var best = rankedFiltered.find(function (r) { return r.step === s && !usedHandles.has(r.handle); });
      if (best) { picked.push(best); usedHandles.add(best.handle); }
    });
    // Fallback fill: SOLO prodotti con step coerente con l'area scelta.
    for (var i = 0; i < rankedFiltered.length && picked.length < n; i++) {
      var r = rankedFiltered[i];
      if (usedHandles.has(r.handle)) continue;
      if (stepsAllowed.size && !stepsAllowed.has(r.step)) continue;
      picked.push(r); usedHandles.add(r.handle);
    }
    return picked;
  }

  /* ---------- Reason — frase editoriale "perché te lo consigliamo" ----------
     Priorità: prima il match prodotto-specifico (concerns/skin types),
     poi safety/preferenze come clausola subordinata. Lingua naturale. */
  function buildReason(m) {
    var parts = [];

    if (m.concerns && m.concerns.length) {
      var c = m.concerns.slice(0, 2).map(function (x) { return String(x).toLowerCase(); });
      var primary = 'per ' + (c.length === 2 ? (c[0] + ' e ' + c[1]) : c[0]);
      if (m.skin && m.skin.length) {
        primary += ', su pelle ' + String(m.skin[0]).toLowerCase();
      }
      parts.push(primary);
    } else if (m.skin && m.skin.length) {
      var ss = m.skin.slice(0, 2).map(function (x) { return String(x).toLowerCase(); });
      parts.push('adatto a pelle ' + (ss.length === 2 ? (ss[0] + ' e ' + ss[1]) : ss[0]));
    }

    if (m.life_stage) parts.push('sicuro in ' + String(m.life_stage).toLowerCase());
    if (m.fragranceFree) parts.push('senza profumo');

    if (!parts.length) return '';
    return capFirst(parts.join(', ')) + '.';
  }

  /* ---------- Riepilogo risposte: chip orizzontali (sostituisce "profilo") ---------- */
  function buildProfileCard() {
    var a = state.answers;
    var tags = [];

    var areaLabel = ({
      'viso': 'Viso', 'corpo': 'Corpo', 'capelli': 'Capelli',
      'viso_corpo': 'Viso e corpo', 'baby': 'Per il bimbo', 'barba': 'Barba'
    })[a.area] || a.area;
    tags.push(capFirst(areaLabel));

    if (a.age && a.age !== 'skip' && DATA.age_labels && DATA.age_labels[a.age]) {
      tags.push(capFirst(DATA.age_labels[a.age]));
    }

    // Concerns: max 2 nei chip (in scoring usiamo tutti)
    (a.concerns || []).slice(0, 2).forEach(function (c) {
      var label = (DATA.concern_labels && DATA.concern_labels[c]) || c;
      tags.push(capFirst(label));
    });

    // Skin types: consolidati in 1 chip se 2+ tipi derivati (era 3+ chip prima)
    var skins = a.derived_skin_types || [];
    if (skins.length === 1) {
      tags.push('Pelle ' + skins[0]);
    } else if (skins.length > 1) {
      tags.push('Pelle ' + skins.slice(0, 3).join(', '));
    }

    // Life-stage PRIMA del lifestyle: è più identitario/safety-related e non deve
    // cadere per il cap a 6 (bug: "ho detto pre-menopausa ma non compare nei chip").
    if (a.life_stage && a.life_stage !== 'nessuna' && a.life_stage !== 'skip') {
      tags.push(capFirst((DATA.life_stage_labels && DATA.life_stage_labels[a.life_stage]) || a.life_stage));
    }

    // Lifestyle: max 1 chip (in scoring usiamo tutti)
    var firstLf = (a.lifestyle || []).find(function (lf) { return lf !== 'nessuna'; });
    if (firstLf) {
      var lfLabel = (DATA.lifestyle_labels && DATA.lifestyle_labels[firstLf]) || firstLf;
      tags.push(capFirst(lfLabel));
    }

    if (a.profumo === 'no') tags.push('Senza profumo');
    else if (a.profumo === 'leggero') tags.push('Profumi leggeri');

    // Hard cap a 6 chip per non saturare visivamente.
    // Ordine di importanza (decrescente): area, age, concern1, concern2, skin, life_stage, lifestyle, profumo.
    // Se superiamo 6, scartiamo le ultime (meno identitarie).
    if (tags.length > 6) tags = tags.slice(0, 6);

    if (!tags.length) return '';

    var html = '<div class="quiz-result__tags">';
    tags.forEach(function (t) {
      html += '<span class="quiz-tag">' + esc(t) + '</span>';
    });
    html += '</div>';
    return html;
  }

  /* ---------- Nota sicurezza: rende VISIBILE l'esclusione ingredienti che il
     motore (isKnockedOut) già applica. Dal test utente: la safety era invisibile
     e l'utente non si fidava. Mostrata solo se c'è un'esclusione reale. ---------- */
  function buildSafetyNote() {
    var a = state.answers;
    var contexts = [];
    var excluded = [];
    if (a.life_stage === 'gravidanza') contexts.push('in gravidanza');
    else if (a.life_stage === 'allattamento' || a.life_stage === 'post-parto') contexts.push('in allattamento');
    if (contexts.length) { excluded.push('retinoidi', 'oli essenziali'); }
    var sensibile = (a.derived_skin_types || []).indexOf('sensibile') !== -1 ||
                    (a.concerns || []).indexOf('sensibile_concern') !== -1;
    if (sensibile) { contexts.push('per pelle sensibile'); excluded.push('acidi attivi'); }
    if (!contexts.length || !excluded.length) return '';
    excluded = excluded.filter(function (x, i) { return excluded.indexOf(x) === i; });
    var ctxStr = contexts.join(' e ');
    var exStr = excluded.length === 1
      ? excluded[0]
      : excluded.slice(0, -1).join(', ') + ' e ' + excluded[excluded.length - 1];
    var text = 'Selezione sicura ' + ctxStr + ': esclusi ' + exStr + '.';
    var shield = '<svg class="quiz-result__safety-icon" viewBox="0 0 16 16" width="15" height="15" aria-hidden="true">' +
                   '<path d="M8 1.5 2.5 3.5v4c0 3 2.3 5.4 5.5 6.5 3.2-1.1 5.5-3.5 5.5-6.5v-4L8 1.5Z" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/>' +
                   '<path d="M5.6 7.8 7.3 9.5 10.6 6" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
                 '</svg>';
    return '<p class="quiz-result__safety">' + shield + '<span>' + esc(text) + '</span></p>';
  }

  /* ---------- Render result ---------- */
  function renderResult() {
    var ranked = scoreCatalog();
    var picked = pickWithDiversity(ranked);

    // Hero reorder: picked[0] è oggi il primo della step-order (es. detersione),
    // ma il "consigliato per te" dovrebbe essere il prodotto col MAX score globale
    // (es. siero anti-rughe se l'utente ha scelto rughe). Riordino.
    if (picked.length > 1) {
      var maxIdx = 0;
      for (var i = 1; i < picked.length; i++) {
        if (picked[i].score > picked[maxIdx].score) maxIdx = i;
      }
      if (maxIdx !== 0) {
        var topItem = picked.splice(maxIdx, 1)[0];
        picked.unshift(topItem);
      }
    }

    // Nota: il track('quiz_complete') è spostato DOPO il fetch dei dati prodotto
    // così l'evento Klaviyo include titoli, prezzi e immagini.

    if (keyHandler) { document.removeEventListener('keydown', keyHandler); keyHandler = null; }

    if (picked.length === 0) {
      resultEl.innerHTML = '<div class="quiz-result"><h2 class="quiz-result__heading">Non abbiamo trovato un match preciso</h2>' +
        '<p class="quiz-result__lede">Le tue risposte indicano un caso particolare. Scrivici, ti aiutiamo a scegliere.</p>' +
        '<div class="quiz-result__cta-row">' +
          '<a class="quiz-btn" href="/pages/contatti">Contattaci</a>' +
          '<a class="quiz-btn quiz-btn--ghost" href="/collections/all">Catalogo completo</a>' +
        '</div></div>';
      resultEl.hidden = false;
      stage.innerHTML = '';
      if (restartBtn) restartBtn.hidden = false;
      updateProgress();
      return;
    }

    // Split hero (top match) + complementary (rest).
    // Approccio B-rivisto: il default selected è SOLO l'hero → anchor commerciale basso,
    // in linea con AOV €60. L'utente aggiunge il resto solo se convinto.
    var hero = picked[0];
    var complementary = picked.slice(1);

    // resultItems: solo hero `included` di default. Sticky CTA mostra €X (1 prodotto).
    resultItems = picked.map(function (p, idx) {
      return { handle: p.handle, variantId: null, price: null, included: idx === 0, score: p.score, step: p.step };
    });

    var name = nameFromEmail(state.answers.email);
    var headingText = name ? ('Il consiglio per <span>' + esc(name) + '</span>') : 'Il tuo consiglio';

    // Helper: rende una singola card prodotto.
    function renderCard(it, isHero) {
      var stepLabel = (DATA.step_labels && DATA.step_labels[it.step]) || { name: it.step, usage: '' };
      var reason = buildReason(it.match);
      var summary = (DATA.product_summaries && DATA.product_summaries[it.handle]) || '';
      var isBundle = !!it.is_set;
      var bundleItems = isBundle && DATA.bundle_contents ? DATA.bundle_contents[it.handle] : null;

      // Per i bundle override l'etichetta step a "Routine completa" / "Starter kit" etc.
      // (lo step `set` non ha un'usage chiara).
      if (isBundle) {
        stepLabel = { name: 'Set Laqqua', usage: bundleItems ? (bundleItems.length + ' prodotti insieme') : 'Routine pronta' };
      }
      var selectedClass = isHero ? ' is-selected' : '';
      var heroClass = isHero ? ' quiz-result__item--hero' : '';
      var ariaPressed = isHero ? 'true' : 'false';
      var ariaLabel = isHero ? 'Rimuovi dalla routine' : 'Aggiungi alla routine';
      var out = '<article class="quiz-result__item' + selectedClass + heroClass + '" data-item-handle="' + esc(it.handle) + '">';
      out +=   '<button type="button" class="quiz-result__select" data-toggle="' + esc(it.handle) + '" aria-pressed="' + ariaPressed + '" aria-label="' + ariaLabel + '">';
      out +=     '<svg viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 8.5 6.5 12 13 5"/></svg>';
      out +=     '<span class="quiz-result__select-label" aria-hidden="true"></span>';
      out +=   '</button>';
      // Niente eyebrow step (era ridondante col titolo prodotto). Il titolo è
      // l'elemento predominante del pannello — vedi CSS (ordine + spostamento info).
      out += '<div class="quiz-result__card" data-loading data-handle="' + esc(it.handle) + '" data-score="' + it.score + '"></div>';
      // Bullet "cosa fa": almeno 3 voci da dati reali (cosa fa · per te · come si usa),
      // con fallback sui concern del prodotto se servono. Niente claim inventati.
      var points = [];
      if (summary) points.push(summary);
      if (reason) points.push(reason);
      if (stepLabel.usage) points.push(capFirst(stepLabel.usage));
      if (points.length < 3) {
        var prod = (DATA.catalog || []).find(function (p) { return p.handle === it.handle; });
        if (prod && prod.concerns) {
          var top = Object.keys(prod.concerns)
            .sort(function (a, b) { return prod.concerns[b] - prod.concerns[a]; })
            .slice(0, 3)
            .map(function (c) { return ((DATA.concern_labels && DATA.concern_labels[c]) || c).toLowerCase(); });
          if (top.length) points.push('Mirato su ' + top.join(', ') + '.');
        }
      }
      // Bundle contents: lista degli "ingredienti" del set, costruisce trust.
      // Posizionata PRIMA dei points perché è il segnale più forte sui bundle.
      if (isBundle && bundleItems && bundleItems.length) {
        out += '<div class="quiz-result__bundle">';
        out +=   '<p class="quiz-result__bundle-label">Cosa contiene</p>';
        out +=   '<ul class="quiz-result__bundle-list">';
        bundleItems.forEach(function (name) {
          out += '<li>' + esc(name) + '</li>';
        });
        out +=   '</ul>';
        out += '</div>';
      }
      if (points.length) {
        out += '<ul class="quiz-result__points">';
        points.forEach(function (p) { out += '<li>' + esc(p) + '</li>'; });
        out += '</ul>';
      }
      out += '</article>';
      return out;
    }

    var html = '<div class="quiz-result">';

    // Email confirmation banner (only if email provided)
    if (state.answers.email) {
      html += '<div class="quiz-result__banner" data-quiz-banner>';
      html += '<span class="quiz-result__banner-icon" aria-hidden="true">✓</span>';
      html += '<span class="quiz-result__banner-text">Routine salvata. La trovi anche nella casella di <strong>' + esc(state.answers.email) + '</strong>.</span>';
      html += '<button type="button" class="quiz-result__banner-close" data-quiz-banner-close aria-label="Chiudi messaggio">×</button>';
      html += '</div>';
    }

    html += '<h2 class="quiz-result__heading">' + headingText + '</h2>';
    html += buildProfileCard();
    html += buildSafetyNote();

    // HERO section
    html += '<section class="quiz-result__hero-section">';
    html += '<h3 class="quiz-result__section-title">Il consiglio principale</h3>';
    html += '<p class="quiz-result__section-sub">Il prodotto più adatto al tuo profilo. Inizia con questo, aggiungi il resto quando vuoi.</p>';
    html += '<div class="quiz-result__routine quiz-result__routine--hero">';
    html += renderCard(hero, true);
    html += '</div>';
    html += '</section>';

    // COMPLEMENTARY section
    if (complementary.length > 0) {
      html += '<section class="quiz-result__complementary-section">';
      html += '<h3 class="quiz-result__section-title">Completa la routine</h3>';
      html += '<div class="quiz-result__routine" data-count="' + complementary.length + '">';
      complementary.forEach(function (it) {
        html += renderCard(it, false);
      });
      html += '</div>';
      // "Aggiungi tutto" CTA per chi vuole completare la routine in 1 click
      html += '<div class="quiz-result__select-all-wrap">';
      html += '<button type="button" class="quiz-result__select-all" data-quiz-select-all>';
      html +=   '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="8" y1="3" x2="8" y2="13"/><line x1="3" y1="8" x2="13" y2="8"/></svg>';
      html +=   '<span>Aggiungi tutto alla routine</span>';
      html += '</button>';
      html += '</div>';
      html += '</section>';
    }

    // Trust badges
    html += '<div class="quiz-result__trust">';
    html += '<span class="quiz-trust">100% Vegan</span>';
    html += '<span class="quiz-trust">Made in Italy</span>';
    html += '<span class="quiz-trust">30 giorni soddisfatti o rimborsati</span>';
    html += '</div>';

    // CTA in pagina rimossa — la sticky CTA (visibile su tutte le viewport) basta.
    // Restano solo i link secondari.
    html += '<div class="quiz-result__cta">';
    html += '<p class="quiz-result__cta-secondary">Oppure ';
    var primaryConcern = (state.answers.concerns || [])[0];
    var collUrl = primaryConcern && DATA.result_concern_collection && DATA.result_concern_collection[primaryConcern];
    if (collUrl) html += '<a href="' + collUrl + '">vedi la collezione completa</a> <span class="quiz-result__sep">·</span> ';
    html += '<a href="/collections/all">esplora il catalogo</a>';
    html += '</p>';
    html += '</div></div>';

    // Sticky mobile CTA — l'intero componente è un bottone cliccabile
    if (!document.querySelector('[data-quiz-sticky]')) {
      var sticky = document.createElement('button');
      sticky.type = 'button';
      sticky.className = 'quiz-sticky-cta';
      sticky.disabled = true;
      sticky.setAttribute('data-quiz-sticky', '');
      sticky.setAttribute('data-sticky-add', '');
      var cartSvg =
        '<svg class="quiz-sticky-cta__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<circle cx="9" cy="21" r="1"/>' +
          '<circle cx="20" cy="21" r="1"/>' +
          '<path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"/>' +
        '</svg>';
      sticky.innerHTML =
        '<span class="quiz-sticky-cta__info">' +
          '<span class="quiz-sticky-cta__count" data-sticky-count>0 prodotti</span>' +
          '<span class="quiz-sticky-cta__price" data-sticky-price></span>' +
        '</span>' +
        '<span class="quiz-sticky-cta__action">' +
          cartSvg + '<span data-sticky-label>Aggiungi al carrello</span>' +
        '</span>';
      document.body.appendChild(sticky);
    }

    resultEl.innerHTML = html;
    resultEl.hidden = false;
    stage.innerHTML = '';
    if (restartBtn) restartBtn.hidden = false;
    updateProgress();
    saveToStorage();
    document.body.classList.add('quiz-result-active');
    // Scroll in cima alla pagina: con header e progress che fadeano via
    // serve resettare la posizione, non basta più scrollare al root.
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // Render product cards via Section Rendering API
    picked.forEach(function (p) { fetchCard(p.handle, p.score); });

    // Fetch prices/variants/title/image in parallel — quando tutti pronti,
    // pushiamo l'evento Klaviyo arricchito con dati prodotto leggibili.
    var productFetches = resultItems.map(function (item, idx) {
      return fetchProductData(item.handle).then(function (data) {
        if (data) {
          item.price = data.price;
          item.variantId = data.variantId;
          item.title = data.title;
          item.image = data.image;
        }
        updateBundleSummary();
        return data;
      });
    });

    // Quando i fetch sono pronti (o dopo 3s safety), push evento Quiz Completed arricchito
    var ev_pushed = false;
    function pushEnrichedEvent() {
      if (ev_pushed) return;
      ev_pushed = true;
      var top_products = resultItems.map(function (it, i) {
        var p = picked[i];
        var info = getStepInfo(it.step);
        var reason = buildReason(p.match);
        return {
          handle: it.handle,
          title: it.title || it.handle,
          price: formatMoney(it.price),
          price_cents: it.price || 0,
          image: it.image || '',
          url: 'https://www.laqqua.com/products/' + it.handle + '?utm_source=klaviyo&utm_medium=email&utm_campaign=quiz_routine&utm_content=' + encodeURIComponent(it.handle),
          step_name: info.name || '',
          step_usage: info.usage || '',
          reason: reason || ''
        };
      });
      var totalCents = resultItems.reduce(function (s, x) { return s + (x.price || 0); }, 0);
      track('quiz_complete', {
        gender: state.answers.gender,
        gender_label: getGenderLabel(state.answers.gender),
        area: state.answers.area,
        area_label: getAreaLabel(state.answers.area),
        age: state.answers.age,
        age_label: getAgeLabel(state.answers.age),
        concerns: state.answers.concerns,
        concerns_labels: getConcernLabels(state.answers.concerns),
        derived_skin_types: state.answers.derived_skin_types,
        lifestyle: state.answers.lifestyle,
        lifestyle_labels: getLifestyleLabels(state.answers.lifestyle),
        life_stage: state.answers.life_stage,
        life_stage_label: getLifeStageLabel(state.answers.life_stage),
        profumo: state.answers.profumo,
        profumo_label: getProfumoLabel(state.answers.profumo),
        format: state.answers.format,
        format_label: getFormatLabel(state.answers.format),
        email_provided: !!state.answers.email,
        top_handles: picked.map(function (p) { return p.handle; }),
        top_products: top_products,
        total_candidates: ranked.length,
        total_price: formatMoney(totalCents),
        total_price_cents: totalCents,
        product_count: resultItems.length
      });
    }
    Promise.all(productFetches.map(function (p) { return p.catch(function () { return null; }); })).then(pushEnrichedEvent);
    setTimeout(pushEnrichedEvent, 3500); // safety timeout

    // Wire toggle selezione per card
    resultEl.querySelectorAll('[data-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (ev) {
        ev.stopPropagation();
        ev.preventDefault();
        var handle = btn.dataset.toggle;
        var item = resultItems.find(function (x) { return x.handle === handle; });
        if (!item) return;
        item.included = !item.included;
        var card = btn.closest('.quiz-result__item');
        if (card) card.classList.toggle('is-selected', item.included);
        btn.setAttribute('aria-pressed', String(item.included));
        btn.setAttribute('aria-label', item.included ? 'Rimuovi dalla routine' : 'Aggiungi alla routine');
        updateBundleSummary();
        track('quiz_item_toggle', { handle: handle, included: item.included });
      });
    });

    // Wire "Aggiungi tutto alla routine" — flippa tutti gli item a included=true
    var selectAllBtn = resultEl.querySelector('[data-quiz-select-all]');
    if (selectAllBtn) {
      selectAllBtn.addEventListener('click', function () {
        var changed = 0;
        resultItems.forEach(function (item) {
          if (!item.included) {
            item.included = true;
            var card = resultEl.querySelector('[data-item-handle="' + item.handle + '"]');
            if (card) {
              card.classList.add('is-selected');
              var tBtn = card.querySelector('[data-toggle]');
              if (tBtn) {
                tBtn.setAttribute('aria-pressed', 'true');
                tBtn.setAttribute('aria-label', 'Rimuovi dalla routine');
              }
            }
            changed++;
          }
        });
        if (changed > 0) {
          updateBundleSummary();
          track('quiz_select_all', { added: changed });
          // Hide the CTA after click — non serve riproporre
          selectAllBtn.style.display = 'none';
        }
      });
    }

    // Wire sticky add-all (l'intero sticky è il bottone, visibile ovunque)
    var stickyBtn = document.querySelector('[data-quiz-sticky]');
    if (stickyBtn) stickyBtn.addEventListener('click', function () { addAllToCart(); });

    // Wire banner close
    var bannerClose = resultEl.querySelector('[data-quiz-banner-close]');
    if (bannerClose) {
      bannerClose.addEventListener('click', function () {
        var b = resultEl.querySelector('[data-quiz-banner]');
        if (b) b.remove();
      });
    }

    // Initial summary update (price unknown yet)
    updateBundleSummary();
  }

  function fetchCard(handle, score) {
    fetch('/products/' + handle + '?section_id=api-product-grid-item', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var slot = resultEl.querySelector('[data-handle="' + handle + '"]');
        if (!slot) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var content = tmp.querySelector('[data-api-content]') || tmp;
        slot.removeAttribute('data-loading');
        slot.innerHTML = content.innerHTML;

        // Hero "scheda prodotto" (desktop): sposta le info prodotto (titolo/rating/
        // prezzo) fuori dalla card, subito DOPO l'immagine, così il titolo è in cima
        // al pannello di destra (col 2). Il CSS gestisce la griglia desktop.
        var heroItem = slot.closest('.quiz-result__item--hero');
        if (heroItem) {
          var info = slot.querySelector('.product-information') || slot.querySelector('.product-item__info');
          if (info && info.parentElement !== heroItem) {
            slot.insertAdjacentElement('afterend', info);
          }
        }

        // Arrotonda rating Judge.me a 1 decimale (4.75 → 4.8).
        // Scope = heroItem quando le info sono state spostate fuori dallo slot.
        (heroItem || slot).querySelectorAll('.jdgm-prev-badge[data-average-rating]').forEach(function (el) {
          var raw = parseFloat(el.getAttribute('data-average-rating'));
          // toFixed(1) per arrotondare (4.75 -> 4.8), poi via lo ".0" finale (5.0 -> 5).
          if (!isNaN(raw)) el.setAttribute('data-average-rating', raw.toFixed(1).replace(/\.0$/, ''));
        });

        slot.addEventListener('click', function () {
          track('quiz_product_click', { handle: handle, score: score });
        }, { capture: true, once: true });
      })
      .catch(function () {});
  }

  function addAllToCart() {
    var included = resultItems.filter(function (x) { return x.included && x.variantId; });
    if (included.length === 0) return;

    var stickyBtn = document.querySelector('[data-quiz-sticky]');
    var stickyLabel = stickyBtn && stickyBtn.querySelector('[data-sticky-label]');
    if (stickyBtn) {
      stickyBtn.disabled = true;
      if (stickyLabel) { stickyLabel.dataset.origText = stickyLabel.textContent; stickyLabel.textContent = 'Aggiungo…'; }
    }

    var items = included.map(function (x) { return { id: x.variantId, quantity: 1 }; });

    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart add failed');
      track('quiz_add_all', { count: items.length, handles: included.map(function (x) { return x.handle; }) });
      if (stickyLabel) stickyLabel.textContent = 'Aggiunti al carrello ✓';
      document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
      document.dispatchEvent(new CustomEvent('theme:product:added'));
      setTimeout(function () {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && !drawer.classList.contains('is-open')) {
          drawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show'));
        }
        if (stickyBtn) stickyBtn.disabled = false;
        if (stickyLabel && stickyLabel.dataset.origText) { stickyLabel.textContent = stickyLabel.dataset.origText; delete stickyLabel.dataset.origText; }
        updateBundleSummary();
      }, 1200);
    }).catch(function () {
      if (stickyBtn) stickyBtn.disabled = false;
      if (stickyLabel) stickyLabel.textContent = 'Riprova';
    });
  }

  function reset() {
    state = freshState();
    clearStorage();
    resultItems = [];
    resultEl.hidden = true; resultEl.innerHTML = '';
    if (restartBtn) restartBtn.hidden = true;
    document.body.classList.remove('quiz-result-active');
    var stickyEl = document.querySelector('[data-quiz-sticky]');
    if (stickyEl) stickyEl.remove();
    var url = new URL(window.location.href);
    url.searchParams.delete('step'); url.searchParams.delete('a');
    history.replaceState({ quiz: true, nodeKey: state.nodeKey }, '', url.toString());
    isInitialLoad = true;
    renderNode();
    // Scroll all'inizio del quiz così l'utente non resta sul footer
    var scrollTarget = root.getBoundingClientRect().top + window.pageYOffset - 16;
    window.scrollTo({ top: Math.max(0, scrollTarget), behavior: 'smooth' });
    track('quiz_restart', {});
  }
  if (restartBtn) restartBtn.addEventListener('click', reset);

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' })[c];
    });
  }

  /* ---------- Boot ---------- */
  readUrlState();
  track('quiz_start', { entry: location.pathname });

  if (state.nodeKey === 'result') {
    renderResult();
  } else if (state.nodeKey !== DATA.start || (state.path && state.path.length)) {
    // URL has saved state — render directly
    var n = DATA.nodes[state.nodeKey];
    if (n && n.type === 'lead_form') renderLeadForm(n);
    else if (n && n.type === 'transition') renderTransition(n);
    else renderNode();
  } else if (maybePromptResume()) {
    // Resume prompt shown
  } else {
    renderNode();
  }
})();
